/* eslint-disable no-debugger */
import { Injectable } from '@angular/core';
import { ServiceWithTotal } from '@/app/interfaces/service';
import axios from 'axios';
import { environment } from '@/environments/environment';
import { ToastService } from './script/toast.service';
import { LoaderService } from '@/app/services/interceptor/loader-service';
interface ApiResponse<T> {
  data: T;
}
@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  private readonly apiUrl = '/api/aurora';

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async getServices(params): Promise<ServiceWithTotal> {
    try {
      this.loader.show();

      const response = await axios.post<ApiResponse<ServiceWithTotal>>(
        `${environment.url}${this.apiUrl}/listado`,
        { filters: { params }, list: 'services' },
        {
          withCredentials: true,
        }
      );
      return response.data.data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener los servicios',
        error?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
